import React from 'react';
import { Section } from '@fiverr-private/layout_components';
import FreelanceImpact from '../FreelanceImpact';

export const Page = () => (
  <Section paddingTop="0" paddingBottom="0">
    <FreelanceImpact />
  </Section>
);
